import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import FetchContainer from "./Components/FetchContainer";
import AccessRequest from "./Components/AccessRequest";
import Login from "./Auth/Login";
import LoadingProfilePreferences from "./Auth/LoadingProfilePreferences";

import { useMsal } from "./Auth/msal-context";

export default function App() {
  return (
    <div className="App">
      <Router>
        <Pages />
      </Router>
    </div>
  );
}

export function Pages() {
  const {
    authing,
    isAuthenticated,
    setUserAltocumulus,
    setUserAltocumulusAccess,
    getToken,
  } = useMsal();

  useEffect(() => {
    if (isAuthenticated) {
      upsertFetchUser();
      checkAltocumulusUserRegistered();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const checkAltocumulusUserRegistered = async () => {
    let accessToken = await getToken();

    fetch(`/api/checkuserregistered`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          let payload = [
            {
              status: response.status,
              rawmsg: response.statusText,
              cleanmsg:
                response.status +
                " was thrown with the message of " +
                response.statusText +
                " on " +
                response.url,
              location: response.url,
              timestamp: Date.now(),
            },
          ];
          throw {
            payload: payload,
            error: new Error(),
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.LeaserID === 0) {
          setUserAltocumulus(data);
          return;
        }
        if (data.isActive && data.TeamId !== 1 && data.TeamId !== 16) {
          setUserAltocumulusAccess(true);
        }
        setUserAltocumulus(data);
      })
      .catch((error) => {
        window.apiError("check user register: " + error);
      });
  };

  const upsertFetchUser = async () => {
    let accessToken = await getToken();

    fetch("/api/upsertFetchUser", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          let payload = [
            {
              status: response.status,
              rawmsg: response.statusText,
              cleanmsg:
                response.status +
                " was thrown with the message of " +
                response.statusText +
                " on " +
                response.url,
              location: response.url,
              timestamp: Date.now(),
            },
          ];
          throw {
            payload: payload,
            error: new Error(),
          };
        }
        return response.json();
      })
      .catch((error) => {
        window.apiError("Upsert Fetch User: " + error);
      });
  };

  if (authing) return <LoadingProfilePreferences wording={"Loading..."} />;
  if (!isAuthenticated) return <Login />;

  return (
    <Switch>
      <Route path="/AccessRequest">
        <AccessRequest />
      </Route>
      <Route path="/">
        <FetchContainer />
      </Route>
    </Switch>
  );
}